import { useFeature } from 'flagged'

import AcquisitionViewSiteNavSection from './AcquisitionViewSiteNavSection'
import HomePageSiteNavSection from './HomePageSiteNavSection'
import LoggedInSiteNavSection from './LoggedInSiteNavSection'
import MinimalSiteNavSection from './MinimalSiteNavSection'
import C6UnifiedSearchLoggedInSiteNavSection from './C6UnifiedSearchLoggedInSiteNavSection'

interface SiteNavSectionProps {
  activeNavItem?: string
  classNames: any
  handleToggleNav: () => void
  showMinimalView: boolean
  showAcquisitionView: boolean
  isLoggedIn: boolean
  trackClick: (eventCta: string) => void
}

const SiteNavSection = ({
  activeNavItem,
  classNames,
  handleToggleNav,
  isLoggedIn,
  showAcquisitionView,
  showMinimalView,
  trackClick,
}: SiteNavSectionProps) => {
  const c6UnifiedSearchPhase0 = useFeature('c6_unified_search_phase_0')

  if (showAcquisitionView) {
    return <AcquisitionViewSiteNavSection classNames={classNames} />
  }

  if (showMinimalView) {
    return (
      <MinimalSiteNavSection
        classNames={classNames}
        handleToggleNav={handleToggleNav}
        trackClick={trackClick}
      />
    )
  }

  if (c6UnifiedSearchPhase0 && isLoggedIn) {
    return (
      <C6UnifiedSearchLoggedInSiteNavSection
        activeNavItem={activeNavItem}
        classNames={classNames}
        handleToggleNav={handleToggleNav}
        trackClick={trackClick}
      />
    )
  }

  if (isLoggedIn) {
    return (
      <LoggedInSiteNavSection
        activeNavItem={activeNavItem}
        classNames={classNames}
        handleToggleNav={handleToggleNav}
        trackClick={trackClick}
      />
    )
  }

  return (
    <HomePageSiteNavSection
      activeNavItem={activeNavItem}
      classNames={classNames}
      handleToggleNav={handleToggleNav}
      trackClick={trackClick}
    />
  )
}

export default SiteNavSection
